import { render, staticRenderFns } from "./iddIncomeSta.vue?vue&type=template&id=177e1afa&scoped=true"
import script from "./iddIncomeSta.vue?vue&type=script&lang=js"
export * from "./iddIncomeSta.vue?vue&type=script&lang=js"
import style0 from "./iddIncomeSta.vue?vue&type=style&index=0&id=177e1afa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e1afa",
  null
  
)

export default component.exports